import React, {useEffect, useRef} from 'react';
import styles from './ErrorAlert.module.css';
import exclamation from "../../../assets/exclamation-circle.png";
import information from "../../../assets/information-circle.png";

interface ErrorAlertProps {
    message: string;
    onClose?: () => void;
    type?: 'error' | 'info';
    className?: string;
    autoClose?: boolean; // 자동 닫기 여부
    autoCloseDelay?: number; // 자동 닫기 지연 시간 (밀리초)
}

//알림 컴포넌트
const ErrorAlert: React.FC<ErrorAlertProps> = ({
                                                   message,
                                                   onClose,
                                                   type = 'error',
                                                   className = '',
                                                   autoClose = true, // 기본적으로 자동 닫기 활성화
                                                   autoCloseDelay = 5000 // 기본 5초
                                               }) => {
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        // 자동 닫기가 활성화되고 onClose 함수가 있을 때만 타이머 설정
        if (autoClose && onClose) {
            timeoutRef.current = setTimeout(() => {
                onClose();
            }, autoCloseDelay);
        }

        // 컴포넌트 언마운트 시 타이머 정리
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [autoClose, autoCloseDelay, onClose]);

    const handleManualClose = () => {
        // 수동으로 닫을 때 타이머 정리
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        if (onClose) {
            onClose();
        }
    };

    const getAlertIcon = () => {
        switch (type) {
            case 'error': //에러 알림
                return exclamation;
            case 'info': //정보 알림
                return information;
            default:
                return exclamation;
        }
    };

    return (
        <div className={styles.alertWrapper}>
            <div className={`${styles.alert} ${styles[type]} ${className}`}>
                <div className={styles.content}>
                    {/*알림 종류별 아이콘*/}
                    <img src={getAlertIcon()} alt={`${type} icon`} className={styles.logo}/>
                    {/*알림 메세지*/}
                    <span className={styles.message}>{message}</span>
                    {/*확인 버튼*/}
                    {onClose && (
                        <button
                            onClick={handleManualClose}
                            className={styles.dismissButton}
                        >
                            확인
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ErrorAlert;